import { useEffect, useState } from 'react';

import { Pane } from '../types';

export const useMoreDropdown = ({ panes, refWrapper, wrapperWidth }: Props) => {
  const [dropdownPanes, setDropdownPanes] = useState<Pane[]>([]);

  useEffect(() => {
    if (!refWrapper.current) return;

    const wrapperWidth = refWrapper.current.offsetWidth;
    // @ts-ignore
    const tabs = [...refWrapper.current.querySelectorAll('[data-name="tab"]')] as HTMLDivElement[];

    setDropdownPanes([]);

    const more = refWrapper.current.querySelector('[data-name="more"]') as HTMLDivElement;
    let size = more.offsetWidth;

    for (let index = 0; index < tabs.length; index++) {
      if (tabs[index].offsetWidth + size > wrapperWidth) {
        setDropdownPanes(panes.slice(index));
        break;
      }
      size += tabs[index].offsetWidth;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panes, wrapperWidth]);

  return dropdownPanes;
};

type Props = {
  refWrapper: React.RefObject<HTMLDivElement>;
  wrapperWidth: number;
  panes: Pane[];
};
